import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faAnchor, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@samskip/frontend-components";

import { TransferPlace } from "@assets/constants";
import { classNames } from "@assets/utilities/classNameUtilities";

type Props = {
  /** Override or extend the style applied to the component. */
  className?: string;
  /** The from place name */
  fromPlace: string;
  /** The transport place to show the correct icon. */
  fromTransportType: TransferPlace;
  /** The to place name. */
  toPlace: string;
  /** The transport place to show the correct icon. */
  toTransportType: TransferPlace;
};

const getRouteIcon = (placeType: TransferPlace): IconProp => {
  switch (placeType) {
    case TransferPlace.ADDRESS:
      return faLocationDot;
    case TransferPlace.PORT:
      return faAnchor;
  }
};

const getRouteFontAwesomeIcon = (placeType: TransferPlace) => {
  return (
    <FontAwesomeIcon
      className="text-neutral-600 mr-2"
      icon={getRouteIcon(placeType)}
    />
  );
};

const TransportRoute = ({
  className,
  fromPlace,
  fromTransportType,
  toPlace,
  toTransportType,
}: Props) => {
  return (
    <Tooltip content={`${fromPlace} - ${toPlace}`}>
      <div
        className={classNames(
          className,
          "flex items-center",
          "overflow-x-hidden"
        )}
      >
        {getRouteFontAwesomeIcon(fromTransportType)}
        <span className="text-neutral-1000 inline-block whitespace-nowrap overflow-x-hidden text-ellipsis">
          {fromPlace}
        </span>
        <span className="ml-3 mr-3">—</span>
        {getRouteFontAwesomeIcon(toTransportType)}
        <span className="text-neutral-1000 inline-block whitespace-nowrap overflow-x-hidden text-ellipsis">
          {toPlace}
        </span>
      </div>
    </Tooltip>
  );
};

export default TransportRoute;
